import React, { useEffect, useState } from 'react';

/**
 * Create the domNode for the portal before rendering the modal.
 * @param {*} WrappedComponent
 */
export default function withDomNode(WrappedComponent) {
    return function DomNodeInjector(props) {
        const [domNode, setDomNode] = useState(null);

        useEffect(() => {
            const div = document.createElement('div');
            document.body.appendChild(div);
            setDomNode(div);

            return () => document.body.removeChild(div);
        }, []);

        return domNode ? (
            <WrappedComponent domNode={domNode} {...props} />
        ) : null;
    };
}
